const locale = require('./generateRatingAttachments.i18n.json');

/*@ngInject*/
const GenerateRatingAttachmentsModalController = function ($rootScope, $scope, options, coreConstant) {

    $scope.i18n = locale;

    $scope.viewModel = {
        ratingAttachmentGroups: options.ratingAttachmentGroups,
        selectedRatingAttachments: [],
        allCheckboxSelected: false,
        title: _.get($scope.i18n, 'title'),
        cancelButton: _.get($scope.i18n, 'cancel'),
        okButton: _.get($scope.i18n, 'confirm')
    };

    $scope.onAllCheckboxClick = function () {
        $scope.viewModel.selectedRatingAttachments = [];
        if ($scope.viewModel.allCheckboxSelected) {
            _.each($scope.viewModel.ratingAttachmentGroups, function (ratingAttachmentGroup) {
                _.each(ratingAttachmentGroup.ratingAttachments, function (ratingAttachment) {
                    ratingAttachment.checked = true;
                    $scope.viewModel.selectedRatingAttachments.push(ratingAttachment.value);
                });
            });
        } else {
            _.each($scope.viewModel.ratingAttachmentGroups, function (ratingAttachmentGroup) {
                _.each(ratingAttachmentGroup.ratingAttachments, function (ratingAttachment) {
                    ratingAttachment.checked = false;
                });
            });
        }
    };

    $scope.onCheckboxClick = function (ratingAttachmentValue) {
        if (_.includes($scope.viewModel.selectedRatingAttachments, ratingAttachmentValue)) {
            _.pull($scope.viewModel.selectedRatingAttachments, ratingAttachmentValue);
        } else {
            $scope.viewModel.selectedRatingAttachments.push(ratingAttachmentValue);
        }
    };

    $scope.canEnableConfirmButton = function () {
        return !(_.size($scope.viewModel.selectedRatingAttachments) === 0);
    };

    $scope.onConfirm = function () {
        $scope.$close({
            selectedRatingAttachments: $scope.viewModel.selectedRatingAttachments
        });
    };

    $scope.onCancel = function () {
        $scope.$dismiss();
    };

    $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
        $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
    });

    $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);
};

angular.module('gw-um-submission')
    .controller('generateRatingAttachmentsModalController', GenerateRatingAttachmentsModalController);
